import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import HeroSection from "@/pages/home/components/HeroSection";
import TopBoard from "@/pages/home/components/TopBoard";
import RankingSwitcher from "@/pages/home/components/RankingSwitcher";
import FansBoard from "@/pages/home/components/FansBoard";
import TopicCategories from "@/pages/home/components/TopicCategories";
import DeepDive from "@/pages/home/components/DeepDive";
import FaqSection from "@/pages/home/components/FaqSection";
import AboutSection from "@/pages/home/components/AboutSection";
import ContactSection from "@/pages/home/components/ContactSection";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main>
        <HeroSection />
        <TopBoard />
        <RankingSwitcher />
        <FansBoard />
        <TopicCategories />
        <DeepDive />
        <FaqSection />
        <AboutSection />
        <ContactSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}